import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { StrategyService } from '../services/strategy.service';
import { ValueService } from '../services/value.service';

export const strategicValueResolver: ResolveFn<Observable<any>> = (route, state) => {
  const strategyService = inject(StrategyService);
  const valueService = inject(ValueService);
  const strategyId = route.params['strategyId'];
  return forkJoin({
    strategy: strategyService.getStrategyById(strategyId),
    values: valueService.getListValue(strategyId)
  })
};
